import { axiosInstance } from "./axios";
import { queryOptions } from "@tanstack/react-query";

export interface SystemInfo {
    commitHash: string;
    lastEtlRun: string | null;
    etlStatus: string;
    lastIngestionGeneralRun: string | null;
    ingestionGeneralStatus: string;
    lastIngestionMatchesRun: string | null;
    ingestionMatchesStatus: string;
    timestamp: string;
}

export interface DatabaseHealth {
    status: string;
    database: string;
    timestamp: string;
}

export interface ApiHealth {
    status: string;
    timestamp: string;
}

const fetchSystemInfo = async (): Promise<SystemInfo> => {
    const { data } = await axiosInstance.get<SystemInfo>("/health/system-info");
    return data;
};

const fetchDatabaseHealth = async (): Promise<DatabaseHealth> => {
    const { data } = await axiosInstance.get<DatabaseHealth>("/health/database");
    return data;
};

const fetchApiHealth = async (): Promise<ApiHealth> => {
    const { data } = await axiosInstance.get<ApiHealth>("/health");
    return data;
};

export const systemInfoQueryOptions = queryOptions({
    queryKey: ["system-info"],
    queryFn: fetchSystemInfo,
    retry: false,
});

export const databaseHealthQueryOptions = queryOptions({
    queryKey: ["health-database"],
    queryFn: fetchDatabaseHealth,
    retry: false,
});

export const apiHealthQueryOptions = queryOptions({
    queryKey: ["health-api"],
    queryFn: fetchApiHealth,
    retry: false,
});
